import { Component, OnInit, OnChanges, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { DeliPriceService } from '../../../service/deli-price/deli-price.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { FileUploader } from 'ng2-file-upload';
import { InterfaceMappingService } from '../../../service/interface-mapping/interface-mapping.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

const URL = 'https://foo.bar.com';

@Component({
  selector: 'wa9183',
  templateUrl: 'wa9183.component.html',
  styleUrls: ['wa9183.component.scss']
})

export class Wa9183Component implements OnInit, OnChanges, DoCheck {

  private owners: any;
  private working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public config = config;
  private production = environment.production;
  private backgroundColor: string;
  private filetypes;
  private queryParam;
  private rowData;
  private uploadobjects;
  private uploadobjects_objectname;
  private selectUploadObjectId: number = 0;
  private uploadpatterns;
  private uploadObjectsPatternId;
  private loadStartAt;
  private uploader: FileUploader;
  private hasBaseDropZoneOver: boolean;
  private hasAnotherDropZoneOver: boolean;
  private response: string;
  private errormessage = '';
  public errorInfo: string = '';
  public selecterrorInfo: string = '';
  public error: boolean = false;
  private active: boolean = false;
  private errmsg: any = '';
  private ownerArrivlabeluseFl: string = '0'
  private ownerShiplabeluseFl: string = '0'
  private selectedOwnerId = null;
  public ownerResult: any;

  private errorList: object[] = [];

  private isShowSendLoading = false;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;
  @Input() uploadType = null;

  public ownerId: FormControl;
  private ownerIdCls = '';
  private urlPatternCls = '';
  private isSubmitButtonEnabled = false;
  private isOwnerlinkedUser = false;
  private linkedownerId;

  private deliveryObjectId = 999;
  private isShowUrlPattern = true;
  private uploadpatternsAll = [];

  constructor(
    private interfaceMappingService: InterfaceMappingService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private ownerService: OwnerService,
    private deliPriceService: DeliPriceService,
  ) {
    this.ownerId = new FormControl('', [Validators.required]);
    this.uploader = new FileUploader({
      url: URL,
      disableMultipart: true
    });

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;

    this.response = '';

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    //document.getElementById('wrap').style.overflow = 'auto';
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;

    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      this.errorInfo;
    }
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public onFileSelected() {
    let inputElement = <HTMLInputElement>document.getElementById('fileupload');
    inputElement.value = null;
    this.errorList = [];

    if (this.uploader.queue.length > 1) {
      this.errorInfo = 'ファイルアップロードは、1ファイルのみ可能です。ファイル選択を初期化します。再度、選び直してください。';
      this.hasBaseDropZoneOver = false;
      this.hasAnotherDropZoneOver = false;
      this.uploader.clearQueue();
    } else {
      var filename = this.uploader.queue[0].file.name;
      var index = filename.lastIndexOf('.');
      var suffix = filename.substr(index + 1);
      if (suffix !== 'xls' && suffix !== 'xlsx' && suffix !== 'csv') {
        this.errorInfo = 'ファイル形式が異なります。ご確認ください。';
        this.hasBaseDropZoneOver = false;
        this.hasAnotherDropZoneOver = false;
        this.uploader.clearQueue();
      } else {
        this.errorInfo = '';
      }
    }
  }

  ngOnInit() {
    this.setOwner();
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        this.working = false;
        console.log(JSON.stringify(outputJson));
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    this.interfaceMappingService
      .uploadobjects()
      .then(outputJson => {
        this.working = false;
        this.filetypes = outputJson.uploadobjects;

        // tslint:disable-next-line:prefer-const
        let matchData = this.filetypes.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadObjectId == this) {
            return true;
          }
        }, Number.parseInt(this.uploadType));

        if (this.deliveryObjectId == Number.parseInt(this.uploadType)) {
          sessionStorage.setItem('uploadobjects', JSON.stringify({
            objectName: '運送料マスタ',
            uploadObjectId: this.deliveryObjectId
          }));
        }
        else {
          if (matchData.length !== 1) {
            this.errorInfo = 'マッピング種別が認識出来ません。';
          }
          sessionStorage.setItem('uploadobjects', JSON.stringify(matchData[0]));
        }

        this.uploadobjects = sessionStorage.getItem('uploadobjects');

        if (this.uploadobjects !== null) {
          this.uploadobjects = JSON.parse(this.uploadobjects);
          this.uploadobjects_objectname = this.uploadobjects.objectName;
        }

        if (this.deliveryObjectId != Number.parseInt(this.uploadType)) {
          this.interfaceMappingService
            .uploadpattern(this.uploadobjects.uploadObjectId)
            // tslint:disable-next-line:no-shadowed-variable
            .then(outputJson => {
              this.working = false;
              this.uploadpatternsAll = outputJson.uploadpatterns;
              // 荷主ユーザの場合、荷主プルダウンで紐づき荷主を選択する
              const loginResult = JSON.parse(sessionStorage.getItem('loginResult'));
              if (loginResult.user.roleId == '3') {
                this.linkedownerId = loginResult.user.linkedownerId;
                this.ownerId.setValue(this.linkedownerId);
                this.filterUploadPatterns();
                this.isOwnerlinkedUser = true;
              } else {
                this.isOwnerlinkedUser = false;
              } 
              if ( this.selectedOwnerId != null ) {
                this.onOwnerSeletChanged();
              } 
            })
            .catch(error => {
              this.working = false;
            });
        }
      })
      .catch(error => {
        this.working = false;
      });

  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onSubmit() {
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;

    if (this.ownerId.value === '') {
      this.errorInfo = '荷主を選択してください。';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    } else {
      this.errorInfo = '';
    }

    if (!this.isSubmitButtonEnabled)
      return;

    if (this.uploader.queue.length < 1) {
      this.errorInfo = 'ファイルを選択してください';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    } else {
      this.errorInfo = '';
    }

    if (this.deliveryObjectId == Number.parseInt(this.uploadType)) {
      console.log('---------- upload delivery')
      this.deliPriceService
        .upload(this.uploader.queue[0]._file, this.ownerId.value)
        .then(outputJson => {
          sessionStorage.setItem('SuccessInfoMessage', 'アップロードが完了しました。');
          this.uploader.clearQueue();
          this.errorList = [];
          this.closeButtonClick.emit(true);
          this.isShowSendLoading = false;
          this.working = false;
        })
        .catch(error => {
          // this.catchError(this.commonService.getErrorList(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
          this.working = false;
        });
    }
    else {
      // tslint:disable-next-line:prefer-const
      let matchData = this.uploadpatterns.filter(function (item, index) {
        // tslint:disable-next-line:triple-equals
        if (item.uploadObjectsPatternId == this) {
          return true;
        }
      }, this.selectUploadObjectId);

      if (matchData.length !== 0) {
        sessionStorage.setItem('uploadpattern', JSON.stringify(matchData[0]));
        this.uploadObjectsPatternId = matchData[0].uploadObjectsPatternId;
        this.loadStartAt = matchData[0].loadStartAt;
        this.selecterrorInfo = '';
        this.error = false;
      } else {
        this.working = false;
        this.selecterrorInfo = 'データマッピング定義の指定をしてください。';
        this.error = true;
        sessionStorage.removeItem('uploadpattern');
        this.isShowSendLoading = false;
        return;
      }

      // 荷主別機能マスタの値を設定
      let ownerFunctionsArray = JSON.parse(sessionStorage.getItem('ownerFunctions')).ownerFunctions;
      if(this.commonService.isArrivlabeluseFl(ownerFunctionsArray,this.ownerId.value)){
        this.ownerArrivlabeluseFl = '1';
      }else{
        this.ownerArrivlabeluseFl = '0';
      }
      if(this.commonService.isShiplabeluseFl(ownerFunctionsArray,this.ownerId.value)){
        this.ownerShiplabeluseFl = '1';
      }else{
        this.ownerShiplabeluseFl = '0';
      }

      this.interfaceMappingService
        .mappedupload(this.ownerId.value, this.uploader.queue[0]._file, this.uploadobjects.uploadObjectId, this.uploadobjects.objectCode, this.uploadObjectsPatternId, this.loadStartAt, this.ownerArrivlabeluseFl, this.ownerShiplabeluseFl)
        .then(outputJson => {
          sessionStorage.setItem('SuccessInfoMessage', 'アップロードが完了しました。' + outputJson.readCount + '件を取り込みました。');
          this.uploader.clearQueue();
          this.errorList = [];
          this.closeButtonClick.emit(true);
          this.isShowSendLoading = false;
          this.working = false;
        })
        .catch(error => {
          // SW-1931
          // レスポンスがない場合、タイムアウトとサーバエラーを区別できないため暫定対応。
          if(error.message == 'サーバへ接続できませんでした。'){
              this.errorInfo = 'アップロード処理中であるか、サーバへ接続できません。管理者へお問い合わせください。';
          }else{
            this.catchError(this.commonService.getErrorList(error));
          }
          this.isShowSendLoading = false;
          this.working = false;
        });
    }
  }

  errchange() {
    let matchData = this.uploadpatterns.filter(function (item, index) {
      if (item.uploadObjectsPatternId == this) {
        return true;
      }
    }, this.selectUploadObjectId);

    if (matchData.length !== 0) {
      this.error = false;
      this.active = true;
    } else {
      this.error = true;
      this.active = false;
    }
  }

  catchError(errorList) {
    this.errorList = errorList;
    this.errorInfo = 'アップロードでエラーが発生しました。下部のエラーメッセージを確認してください';
  }

  onDeleteAttachment(index) {
    this.errorInfo = '';
    this.uploader.removeFromQueue(this.uploader.queue[index]);
    this.errorList = [];
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      if (this.isOwnerlinkedUser) {
        this.ownerId.setValue(this.linkedownerId);
      } else if (this.selectedOwnerId != null) {
        this.ownerId.setValue(this.selectedOwnerId);
      }
      this.setOwner();
      // this.selectUploadObjectId = 0;
      this.uploader.clearQueue();
      this.errorList = [];
      this.ownerIdCls = '';
      this.urlPatternCls = '';
      this.isShowUrlPattern = this.deliveryObjectId != Number.parseInt(this.uploadType);
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  ngDoCheck() {
    if (this.uploader.queue.length > 0) {
      // this.onFileSelected();
    }

    if (!this.isShow)
      return;

    this.ownerIdCls = this.ownerId.value == '' ? '' : 'active';
    this.urlPatternCls = this.selectUploadObjectId == 0 ? '' : 'active';
    this.checkSubmitButtonState();
  }

  cancel() {
    this.closeButtonClick.emit(false);
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled = this.ownerIdCls == 'active' &&
      (this.deliveryObjectId == Number.parseInt(this.uploadType) ? true : (this.urlPatternCls == 'active')) && this.uploader.queue.length > 0;
  }

  onOwnerSeletChanged () {
    this.onSeletChanged()
    this.filterUploadPatterns()
  }
  onSeletChanged() {
    this.errorInfo = '';
    this.errorList = [];
  }

  filterUploadPatterns () {
    const resultOwner = []
    const resultCommon = [];
    const selectedOwner = Number(this.ownerId.value)
    this.uploadpatternsAll.forEach(up => {
      if (selectedOwner === 0) {
        resultCommon.push(up)
        return;
      }
      const { owners } = up;
      if (owners.length === 0) {
        resultCommon.push(up)
      } else if (owners.filter(o => o.ownerId === selectedOwner).length > 0) {
        resultOwner.push(up)
      }
    })
    this.uploadpatterns = resultOwner.concat(resultCommon)
    this.selectUploadObjectId = this.uploadpatterns.length > 0 ? this.uploadpatterns[0].uploadObjectsPatternId : 0
  }

  setOwner() {
    this.ownerResult = sessionStorage.getItem('ownerResult');
    this.selectedOwnerId = null;
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.selectedOwnerId = selectedOwner.ownerId === undefined ? null : selectedOwner.ownerId;
      this.ownerId.setValue(selectedOwner.ownerId === undefined ? '' : selectedOwner.ownerId);
    } else {
      this.ownerId.setValue('');
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9183/wa9183.component.ts